// Acțiunile utilizatorului → operații. Interfața nu modifică niciodată datele direct.
import type { Copy, Reading, Work, Member } from '../../shared/types';
import { mutate, newId } from '../sync/engine';

const opId = () => newId();

export async function addBook(work: Partial<Work>, copy: Partial<Copy>, existingWorkId?: string) {
  const workId = existingWorkId || newId();
  const ops: any[] = [];
  if (!existingWorkId) ops.push({ op_id: opId(), type: 'create', entity: 'works', id: workId, fields: work });
  const copyId = newId();
  ops.push({ op_id: opId(), type: 'create', entity: 'copies', id: copyId, fields: { ...copy, work_id: workId } });
  await mutate(ops);
  return { workId, copyId };
}

export function updateWork(id: string, fields: Partial<Work>) {
  return mutate([{ op_id: opId(), type: 'update', entity: 'works', id, fields }]);
}

export function updateCopy(id: string, fields: Partial<Copy>) {
  return mutate([{ op_id: opId(), type: 'update', entity: 'copies', id, fields }]);
}

export function updateCopies(ids: string[], fields: Partial<Copy>) {
  return mutate(ids.map(id => ({ op_id: opId(), type: 'update' as const, entity: 'copies' as const, id, fields })));
}

export function updateWorks(ids: string[], fields: Partial<Work>) {
  return mutate(ids.map(id => ({ op_id: opId(), type: 'update' as const, entity: 'works' as const, id, fields })));
}

export function deleteCopies(ids: string[]) {
  return mutate(ids.map(id => ({ op_id: opId(), type: 'delete' as const, entity: 'copies' as const, id })));
}

export function deleteWork(id: string) {
  return mutate([{ op_id: opId(), type: 'delete', entity: 'works', id }]);
}

export function setReading(workId: string, fields: Partial<Reading>) {
  return mutate([{ op_id: opId(), type: 'reading.set', work_id: workId, fields }]);
}

export function updateMember(id: string, fields: Partial<Member>) {
  return mutate([{ op_id: opId(), type: 'update', entity: 'members', id, fields }]);
}

export function createMember(fields: Partial<Member>) {
  return mutate([{ op_id: opId(), type: 'create', entity: 'members', id: newId(), fields }]);
}
